import { IrisPermissionSubjectI } from '../../../models/IrisPermission';

export enum FolderPermissionActionType {
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
  Config = 'config',
}

export interface FolderPermissionActionI {
  action: FolderPermissionActionType;
  icon: string;
  label: string;
}

export interface IrisDmsFolderPermissionI {
  id: number;
  name: string;
  subjects: IrisPermissionSubjectI[];
}

export const IrisDmsPermissionSubject = 'nt:folder';
